export const randomStr8: () => string = () => {
  const lowercase = "abcdefghijklmnpqrstuvwxyz";
  const uppercase = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const numbers = "23456789";
  const allChars = lowercase + uppercase + numbers;

  let result = [
    lowercase[Math.floor(Math.random() * lowercase.length)],
    uppercase[Math.floor(Math.random() * uppercase.length)],
    numbers[Math.floor(Math.random() * numbers.length)],
  ];

  for (let i = 3; i < 8; i++) {
    result.push(allChars[Math.floor(Math.random() * allChars.length)]);
  }
  return result.sort(() => Math.random() - 0.5).join("");
};
